import React from 'react';
import TextField from '@mui/material/TextField';

const InputResponse = (props) => {
  const { answer } = props;
  return (
    <TextField
      variant="standard"
      name="completion_mark[options][answer]"
      defaultValue={answer}
      {...props}
    />
  );
};
export default InputResponse;
